import { useEffect } from "react";
import { useDispatch } from "react-redux";
import IVenueSettings from '../interfaces/IVenueSettings';
import IVenue from '../interfaces/IVenue';
import { useSelector } from "react-redux";
import { IReduxAppState } from "../reducers";
import { useAPIV2 } from '../yoello-lib/modules/API2/useAPIv2';
import APIExtensions from '../yoello-lib/modules/API2/APIDefs';
import { setPaymentStage } from "../actions/payment";

export function usePay360Account() {
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const {apiData: settingsData, isLoading: isloading } = useAPIV2<IVenueSettings>(APIExtensions.venueSettings, {
        canAPIGetCacheValue: true,
        selectorKeyParams: { venue_id: selectedVenueId },
        dispatcherParams: [selectedVenueId],
    });

    const { apiData: venuesData } = useAPIV2<IVenue>(
        APIExtensions.venues,
        {
            query: selectedVenueId,
            canAPIGetCacheValue: true,
            selectorKeyParams: { venue_id: selectedVenueId },
            dispatcherParams: [selectedVenueId],

        }
    );

    const dispatch = useDispatch();
    async function requestPaymentStage() {
        if (settingsData?.is_pay360_payments_setup) {
            dispatch(setPaymentStage(2));
        } else dispatch(setPaymentStage(1));
    }
    useEffect(() => {
        if (settingsData?.is_pay360_payments_setup) {
            dispatch(setPaymentStage(2));
        } else dispatch(setPaymentStage(1));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingsData]);
    useEffect(() => {
        if (isloading) {
            dispatch(setPaymentStage(-1));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isloading]);
    return { requestPaymentStage, venuesData }
}